import { SearchFilters } from 'conversations/modules/conversation/api'
import { FilterOrderValue } from 'conversations/utils/prospectingFilterOptions'
import { Query, QueryProps } from 'shared/typings/conversations/query'
import { ConversationStatus } from 'shared/typings/conversations/status/ConversationStatus'
import { SortOrder } from 'shared/typings/search/SortOrder'

export const PARTICIPANT_EMPTY_KEY = 0
const DEFAULT_SORT_BY = FilterOrderValue.LAST_OPENED_AT

export const buildConversationsQuery = ({
  inboxId,
  sortBy = DEFAULT_SORT_BY,
  sortOrder = SortOrder.DESC,
  excludedInboxIds,
  excludeIds,
  statuses = [],
  limit = 10,
}: QueryProps) => ({
  limit,
  sortBy,
  sortOrder,
  statuses,
  inboxId,
  excludedInboxIds,
  excludeIds,
})

export const buildConversationSearchFiltersFromQuery = (query: QueryProps) => {
  const filters: SearchFilters = {}

  if (query.inboxId) {
    filters.inboxIdList = [query.inboxId]
  }

  if (query.statuses.length !== 0) {
    filters.statusList = query.statuses
  }
  return filters
}

interface FetchProspectingConverastionListProps {
  userId: number
  onlyClosed?: boolean
}

export const buildMyConversationsQuery = ({
  userId,
  onlyClosed,
}: FetchProspectingConverastionListProps): Query => {
  return {
    limit: 30,
    sortBy: DEFAULT_SORT_BY,
    sortOrder: SortOrder.DESC,
    statuses: onlyClosed
      ? [ConversationStatus.CLOSED]
      : [ConversationStatus.OPEN, ConversationStatus.CLOSED, ConversationStatus.PENDING],
    tags: [],
    participantIds: [[userId]],
  }
}
